import React, { useEffect, useState } from "react";
import { FloatLabel } from "primereact/floatlabel";
import { InputNumber } from "primereact/inputnumber";
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
export default function SysCheckListDetail({ isOpen, onClose, initialData }) {
  const [formData, setFormData] = useState({
    id: 0,
    currentId: 0,
    date: new Date().toISOString(),
    voucherNo: "",
    currentTitle: "",
    voucherRows: [],
  });

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    }
  }, [initialData]);

  const footer = () => (
    <div className="   flex justify-content-between w-full align-items-center">
      {/* Toplam Ürün Sayısı */}
      <span className="pl-3 text-center">
        Toplam {formData?.voucherRows?.length} ürün seçildi
      </span>
    </div>
  );

  return (
    <Dialog
      className="max-w-full w-11 md:w-11 xl:w-9"
      visible={isOpen}
      footer={footer()}
      onHide={onClose}
      header={"Ceki Listesi Görüntüle"}
    >
      <div className="pt-4 ">
        <div className="flex grid">
          {/* Seçilen Ürünler Bölümü */}
          <div className="col-12 ">
            <Card
              title="Müşteri Kumaş Bilgileri"
              className="shadow-3 border-round-md"
            >
              <div style={{ maxHeight: "50.7vh", overflowY: "auto" }}>
                {formData?.voucherRows?.map((product, index) => (
                  <div
                    key={index}
                    className="flex  mt-3 align-items-center justify-content-between 
                       border-1 surface-border border-round shadow-2 mb-1"
                  >
                    <div className="col-12">
                      {/* Ürün Başlığı */}
                      <div className="flex mb-3 justify-content-between">
                        <div className="font-medium pl-2   align-content-center text-primary">
                          {product.stockName}
                        </div>
                      </div>

                      {/* Input Alanları */}
                      <div className="grid">
                        <div className="col-6 md:col-3 mt-2">
                          <FloatLabel>
                            <InputNumber
                              useGrouping={false}
                              className={`w-full ${
                                !product.parcel ? "p-invalid" : ""
                              }`}
                              value={product.parcel || null}
                              readOnly
                            />
                            <label htmlFor="parcel">Parti No</label>
                          </FloatLabel>
                        </div>
                        <div className="col-6 md:col-3 mt-2">
                          <FloatLabel>
                            <InputNumber
                              className={`w-full ${
                                !product.kilos ? "p-invalid" : ""
                              }`}
                              value={product.kilos || null}
                              readOnly
                            />
                            <label htmlFor="kilos">Kilo</label>
                          </FloatLabel>
                        </div>

                        <div className="col-6 md:col-3 mt-2">
                          <FloatLabel>
                            <InputNumber
                              className={`w-full ${
                                !product.meters ? "p-invalid" : ""
                              }`}
                              value={product.meters || null}
                              readOnly
                            />
                            <label htmlFor="meters">Metre</label>
                          </FloatLabel>
                        </div>

                        <div className="col-6 md:col-3 mt-2">
                          <FloatLabel>
                            <InputNumber
                              className={`w-full ${
                                !product.rollCount ? "p-invalid" : ""
                              }`}
                              value={product.rollCount || null}
                              readOnly
                            />
                            <label htmlFor="rollCount">Top</label>
                          </FloatLabel>
                        </div>
                        <div className="col-12 mt-2">
                          <div className="p-inputgroup flex-1">
                            <span className="p-inputgroup-addon min-w-min md:w-2">
                              İşlem Talimatı
                            </span>
                            <InputText
                              className={`w-full  `}
                              value={product.processInstruction || ""}
                              readOnly
                            />
                          </div>
                        </div>

                        <div className="col-12 md:col-6 mt-2">
                          <div className="p-inputgroup flex-1">
                            <span className="p-inputgroup-addon  min-w-min md:w-4">
                              İstenen En
                            </span>
                            <InputText
                              className={`w-full  `} 
                              value={product.requestedWidth || ""}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-12 md:col-6 mt-2">
                          <div className="p-inputgroup flex-1"> 
                            <span className="p-inputgroup-addon  min-w-min md:w-4">
                              Sarım Şekli
                            </span>
                            <InputText
                              className={`w-full  `}
                              value={product.rollStyle || ""}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-12  mt-2">
                          <div className="p-inputgroup flex-1">
                            <span className="p-inputgroup-addon  min-w-min md:w-2">
                              Açıklama
                            </span>
                            <InputTextarea
                              readOnly
                              className={`w-full  `}
                              value={product.description || ""}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </Card>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
